module.exports = __webpack_public_path__ + "static/media/upload.427b082f.svg";